import React, { Children, FC, memo } from 'react';
import { NavLink, useMatches } from 'react-router-dom';

import { dom } from 'app/utils';
import { BreadCrumb as Component, BreadCrumbProps as Props, MenuItem, MenuItemOptions } from './external';
import { Icon } from './common';
import { IComponent } from './types';

export interface IPathItem {
  id?: string;
  icon?: string;
  label?: string;
  url?: string;
}

export interface IBreadcrumb extends IComponent {
  path?: IPathItem[];
}

const menuitem = (item: MenuItem, options: MenuItemOptions) => {
  const props: any = {
    className: dom.className(options.className, { 'cursor-default': !item.url }),
    disabled: item.disabled,
    'data-pc-section': 'action',

    onClick: options.onClick,

    children: Children.toArray([
      (item.icon && <Icon name={item.icon} className={['p-menuitem-icon', item.className]} />),
      (item.label && <span className={dom.className(options.labelClassName, item.className)} data-pc-section="label">{item.label}</span>),
    ]),
  };

  return (item.url ? <NavLink to={item.url} { ...props } /> : <span { ...props } />);
};

export const Breadcrumb: FC<IBreadcrumb> = memo(({ id, className, style, path }: IBreadcrumb) => {
  const matches = useMatches();
  if (!path) path ??= matches.filter(({ handle }: any) => !handle?.exclude).map<IPathItem>(({ data, handle, pathname, params }: any, i, all) => ({
    icon: (!i ? 'mdi-dashboard' : undefined),
    label: (i ? (typeof handle?.title === 'function' ? handle.title(data, params) : handle?.title) : undefined),
    url: (i < all.length - 1 ? pathname : undefined),
  }));

  const model = path.map<MenuItem>((item) => ({ ...item, template: menuitem }));
  const home = model.shift();

  const breadcrumb: Props = { id, style, home, model,
    className: dom.className('i-component', 'i-breadcrumb', className),
  };

  return (
    <Component { ...breadcrumb } />
  );
});
